// 为了处理部分接口接受直辖市的citycode而无法识别其对应的省code
const provinceLevelCity = [110000, 120000, 310000, 500000]

export default function changePrivinceCodeToCityCode(citycode) {
  citycode = citycode ? Number(citycode) : 320100
  if (provinceLevelCity.includes(citycode)) {
    citycode += 100
  }
  return citycode
}
